import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import {
  O2OPartnerAddInterface,
  O2OPartnerDetailsInterface,
  O2OPartnerEditInterface,
  O2OPartnerListingInterface,
  O2OPartnerSummaryInterface
} from "../interfaces/o2o-partner.interface";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class O2OPartnerService {
  private basePath: string = `${environment.url}/api/O2OPartner`;

  constructor(private http: HttpClient) {}

  getPartnerSummary(): Observable<O2OPartnerSummaryInterface> {
    return this.http.get<O2OPartnerSummaryInterface>(
      `${this.basePath}/GetPartnerSummary`
    );
  }

  getListing(
    limit: number,
    offset: number,
    text: string,
    columnIndex: number,
    sortDirection: string,
    startDate: null,
    endDate: null,
    policyStatusList?: string[]
  ): Observable<{ count: number; data: O2OPartnerListingInterface[] }> {
    return this.http.post<{
      count: number;
      data: O2OPartnerListingInterface[];
    }>(`${this.basePath}/GetListing`, {
      limit,
      offset,
      text,
      columnIndex,
      sortDirection,
      startDate,
      endDate,
      policyStatusList
    });
  }

  getPolicyListingExcel(
    limit: number,
    offset: number,
    text: string,
    columnIndex: number,
    sortDirection: string,
    startDate: null,
    endDate: null,
    policyStatusList?: string[]
  ): Observable<Blob> {
    return this.http.post(
      `${this.basePath}/GetPolicyListingExcel`,
      {
        limit,
        offset,
        text,
        columnIndex,
        sortDirection,
        startDate,
        endDate,
        policyStatusList
      },
      { responseType: "blob" }
    );
  }

  add(payload: O2OPartnerAddInterface) {
    const formData = new FormData();
    formData.append("name", payload.name);
    formData.append("industrySectorId", payload.industrySectorId);
    formData.append("registrationNo", payload.registrationNo);
    payload.companyDocuments.forEach((doc) => {
      formData.append(`companyDocuments`, doc);
    });
    formData.append("urlSlug", payload.urlSlug);
    formData.append("themeColor", payload.themeColor);
    formData.append("logo", payload.logo[0]);
    formData.append("banner", payload.banner[0]);
    return this.http.post(`${this.basePath}/Add`, formData);
  }

  getById(id: string): Observable<O2OPartnerDetailsInterface> {
    return this.http
      .get<O2OPartnerDetailsInterface>(`${this.basePath}/GetById/${id}`)
      .pipe(
        map((res) => ({
          ...res,
          companyDocuments: res.companyDocuments.map((doc) => ({
            ...doc,
            UI_isDeleted: false
          })),
          logo: { ...res.logo, UI_isDeleted: false },
          banner: { ...res.banner, UI_isDeleted: false }
        }))
      );
  }

  update(id: string, payload: O2OPartnerEditInterface) {
    const formData = new FormData();
    for (const key in payload) {
      if (payload[key] !== undefined && payload[key] !== null) {
        if (Array.isArray(payload[key])) {
          payload[key].forEach((item) => {
            formData.append(key, item);
          });
        } else {
          formData.append(key, payload[key]);
        }
      }
    }

    return this.http.post(`${this.basePath}/Update/${id}`, formData);
  }
}